import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui';
import { trackEvent } from '../../lib/analytics';

export interface UpgradePromptProps {
  feature: 'media' | 'analytics';
  onDismiss?: () => void;
}

const copy = {
  media: {
    title: 'Add photos and videos to observations',
    description: 'Share the visual story with parents. Upgrade to Sprout for R499/month.',
    minTier: 'Sprout',
    price: 'R499/mo',
  },
  analytics: {
    title: 'Unlock the Analytics dashboard',
    description: 'Track trends across your centre with advanced analytics.',
    minTier: 'Sprout',
    price: 'R499/mo',
  },
} as const;

export const UpgradePrompt: React.FC<UpgradePromptProps> = ({ feature, onDismiss }) => {
  const c = copy[feature];

  useEffect(() => {
    trackEvent('upgrade_prompt_viewed', { feature });
  }, [feature]);

  return (
    <div
      data-testid="upgrade-prompt"
      className="rounded-xl bg-gradient-to-br from-primary-50 to-secondary-50 dark:from-primary-900/20 dark:to-secondary-900/20 border border-primary-200 dark:border-primary-800 p-6"
    >
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{c.title}</h3>
      <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{c.description}</p>
      <div className="mt-4 flex items-center gap-3 flex-wrap">
        <Link to="/pricing" onClick={() => trackEvent('upgrade_cta_clicked', { feature })}>
          <Button variant="primary" size="sm">
            Upgrade to {c.minTier}
          </Button>
        </Link>
        <span className="text-sm text-gray-500 dark:text-gray-400">{c.price}</span>
        {onDismiss && (
          <Button variant="ghost" size="sm" onClick={onDismiss}>
            Not now
          </Button>
        )}
      </div>
    </div>
  );
};

export default UpgradePrompt;
